export default "__VITE_ASSET__af03b845__"